'use client'

import React, { Suspense, useEffect } from "react";
// my imports:
// components / hooks / context
import Core from "@/app/components/Core";
import Menu from "@/app/components/Menu";
import Debug from "@/app/components/Debug";
import Tutorial from "@/app/components/Tutorial";
import OriginalWordHint from "@/app/components/OriginalWordHint";
import LevelMenu from "@/app/components/LevelMenu";
import { AllContexts } from "@/app/components/Context";
import PageWrapper from "@/app/components/PageWrapper";
// library
import { AnyGameObj, } from "@/app/lib/game-state/game-types";
import useSetup from "@/app/lib/setup/setup";
import { latestVersions } from "@/app/lib/system/latest-versions";
import * as Util from "@/app/lib/system/util";
import NewURLWarning from "@/app/components/NewURLWarning";
import { Path } from "@/app/lib/routing/path";
import StoryTutorial from "@/app/components/StoryTutorial";
// styles
import animation from "@/app/styles/animation.module.css";

type MainProps = {
    initialPath: Path | null,
    debugMode: boolean
}

export default function Main({ initialPath, debugMode } : MainProps) {

    // IMPORTANT, THE CURRENT PUZZLE VERSION
    const puzzleDictionaryName: string = 'puzzle-claude';
    const solutionsDictionaryName: string = 'solutions-claude';

    const setup = useSetup(
        initialPath,
        debugMode,
        latestVersions,
        puzzleDictionaryName,
        solutionsDictionaryName
    );

    // destructure the setup return
    const {
        gameManager,
        ui
    } = setup;

    // get the active game
    const activeGame: AnyGameObj = gameManager.active;

    // Domain info
    let oldDomain = false;
    const domain = typeof window !== "undefined"
        ? window.location.origin
        : "";

    if (
        domain === 'https://www.playwordsalad.com/'
        || domain === 'https://www.playwordsalad.com'

    ) {
        oldDomain = true;
    }

    Util.devLog(activeGame.state);

    if (gameManager.activeMode === 'story' && ui.path === '/story/levels') {
        return (
            <>
            <AllContexts
                gameManager={gameManager}
                activeGame={activeGame}
                ui={ui}
            >
                <LevelMenu />
            </AllContexts>
            </>
        )
    }

    if (gameManager.activeMode === 'story' && ui.path === '/story/tutorial') {
        return (
            <>
            <AllContexts
                gameManager={gameManager}
                activeGame={activeGame}
                ui={ui}
            >
                <StoryTutorial />
            </AllContexts>
            </>
        )
    }

    return (
        <>
        <AllContexts
                gameManager={gameManager}
                activeGame={activeGame}
                ui={ui}
        >

            {ui.path === '/tutorial'
                && !oldDomain
                && <Tutorial
                    gameLoaded={ui.isLoaded.pyramid}
            />}
 
            <OriginalWordHint />

            {oldDomain 
                && <NewURLWarning 
                    gameManager={gameManager}
                    ui={ui}
            />}

            <PageWrapper
                activeGame={activeGame}
                ui={ui}
            >
                    <Core 
                        subtitle={gameManager.activeMode === 'story'
                                ? `"${gameManager.story.state.levelName}"`
                                : ''
                        }
                        isLoaded={ui.isLoaded[gameManager.activeMode]}
                    />

                    <Menu />
                
                
                <div className="debugArea">
                    <Debug />
                </div>
            

            </PageWrapper>
        </AllContexts>
        </>
    )

}